// レストランカテゴリーの定数定義
export const FOOD_CATEGORIES = [
  "和食", 
  "洋食", 
  "中華", 
  "イタリアン", 
  "フレンチ",
  "カレー", 
  "アジア料理", 
  "ハンバーガー", 
  "ラーメン", 
  "寿司",
  "焼肉", 
  "居酒屋", 
  "カフェ・喫茶", 
  "スイーツ", 
  "パン", 
  "ファストフード",
  "その他"
];

// カテゴリー選択のバリデーション定数
export const MAX_CATEGORIES = 3;
export const MIN_CATEGORIES = 0;

// 評価関連の定数
export const MIN_RATING = 1;
export const MAX_RATING = 5;

// UI関連の定数
export const DEFAULT_MARKER_COLOR = "#FF5722"; // オレンジ色（統一）
export const DEFAULT_CATEGORY_COLOR = "#888888";
export const DEFAULT_CATEGORY_ICON = "🍽️";
